export default __webpack_public_path__ + "0278ab0b48dd65e4c43b864a077c8d0c.gif";